import { Table, type TableTdProps } from '@mantine/core';
import classes from './NumCell.module.css';

// Числовая ячейка таблицы — с табличными цифрами. Ячейки с текстом, датами и бейджами остаются обычным Table.Td.
export default function NumCell({ className, ...props }: TableTdProps) {
  return <Table.Td {...props} className={className ? `${classes.num} ${className}` : classes.num} />;
}
